export const SET_COPILOT_NOTIFICATION_FEEDBACK_MUTATION = `
  mutation SetCopilotFeedback($notificationId: ID!, $studentFeedback: Boolean, $studentFeedbackNotes: String) {
    setCopilotNotificationFeedback(input: {notificationId: $notificationId, studentFeedback: $studentFeedback, studentFeedbackNotes: $studentFeedbackNotes}) {
      notificationId
      studentFeedback
      studentFeedbackNotes
    }
  }
`;
